import { createSlice } from "@reduxjs/toolkit";

export const editUserSlice = createSlice({
    name:"editUser",
    initialState: {
        showEditUserModal:false,
        selectedUser: null,
    },
    reducers:{
        setShowEditUserModal: (state) => {
            state.showEditUserModal = !state.showEditUserModal;
        },
        setSelectedUser: (state, action)=> {
            state.selectedUser = action.payload;
        },
        resetEditUser: (state)=> {
            state.showEditUserModal = false;
            state.selectedUser = null;
        },
    }
});

export const { setShowEditUserModal, setSelectedUser, resetEditUser } = editUserSlice.actions;

export default editUserSlice.reducer;